import FroalaEditor from 'froala-editor';
import { asyncUpload } from '../../../../utils/s3';
import { dataURLtoFile } from '../../../../utils/dataURLtoFile';

const makeConfig = (options) => {
  FroalaEditor.DefineIconTemplate('material_design', '<i class="material-icons">[NAME]</i>');
  FroalaEditor.RegisterCommand('titleSize', {
    icon: '<div style="font-size:24px;font-weight:bold;margin:0 10px;color:#424242;">제목</div>',
    undo: true,
    callback: function () {
      this.commands.clearFormatting();
      this.commands.bold();
      this.format.applyStyle('color', '#424242');
      this.format.applyStyle('font-size', '24px');
      this.format.applyStyle('line-height', '38px');
    },
  });
  FroalaEditor.RegisterCommand('contentSize', {
    icon: '<div style="font-size:18px;font-weight:normal;margin:0 10px;color:#424242;">본문</div>',
    undo: true,
    callback: function () {
      this.commands.clearFormatting();
      this.lineHeight.apply('');
    },
  });
  FroalaEditor.RegisterCommand('descSize', {
    icon: '<div style="font-size:13px;font-weight:normal;margin:0 10px;color:#b2b2b2;">주석</div>',
    undo: true,
    callback: function () {
      this.commands.clearFormatting();
      this.format.applyStyle('color', '#b2b2b2');
      this.format.applyStyle('font-size', '13px');
      this.format.applyStyle('line-height', '21px');
    },
  });
  FroalaEditor.RegisterCommand('blackColor', {
    title: '본문',
    icon:
      '<div style="width:24px;height: 24px;background:#424242;border-radius:50%;margin:0 10px;"></div>',
    undo: true,
    callback: function () {
      this.format.applyStyle('color', '#424242');
    },
  });
  FroalaEditor.RegisterCommand('lightColor', {
    title: '주석',
    icon:
      '<div style="width:24px;height: 24px;background:#b2b2b2;border-radius:50%;margin:0 10px;"></div>',
    undo: true,
    callback: function () {
      this.format.applyStyle('color', '#b2b2b2');
    },
  });
  FroalaEditor.RegisterCommand('highlightColor', {
    title: '하이라이트',
    icon:
      '<div style="width:24px;height: 24px;background:#f97f54;border-radius:50%;margin:0 10px;"></div>',
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      this.format.applyStyle('color', '#f97f54');
    },
  });
  return {
    attribution: false,
    toolbarButtons: [
      ['titleSize', 'contentSize', 'descSize'],
      ['bold', 'underline', 'quote'],
      ['blackColor', 'lightColor', 'highlightColor'],
      ['insertImage', 'insertVideo', 'insertLink'],
      ['emoticons'],
    ],
    // },
    toolbarButtonsXS: [
      ['titleSize', 'contentSize', 'descSize'],
      ['bold', 'underline', 'quote'],
      ['blackColor', 'lightColor', 'highlightColor'],
      ['insertImage', 'insertVideo', 'insertLink'],
      ['emoticons'],
    ],
    key: 'nQE2uC1D1F1C1C4A1lE-13sryplB-21hA2ytqaG3C2A5A4C4D3B2D4F2D2==',
    charCounterCount: false,
    height: 500,
    imageUploadRemoteUrls: false,
    placeholderText: '호스트님의 멋진 남의집 스토리를 들려주세요! 😄',
    pastePlain: true,
    wordPasteKeepFormatting: false,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    pasteDeniedTags: ['img'],
    wordPasteModal: false,
    linkConvertEmailAddress: true,
    toolbarInline: false,
    toolbarSticky: false,
    videoUpload: true,
    imageUpload: true,
    fileUpload: false,
    language: 'ko',
    imageEditButtons: [
      'imageAlign',
      '|',
      'imageLink',
      'linkOpen',
      'linkEdit',
      'linkRemove',
      'imageRemove',
    ],
    imageDefaultAlign: 'left',
    imageDefaultWidth: 0,
    imageDefaultDisplay: 'block',
    quickInsertEnabled: false,
    imageMaxSize: 5 * 1024 * 1024,
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    events: {
      'image.beforePasteUpload': function (image) {
        const file = dataURLtoFile(image.src, 'PASTED_ITEM');
        image.src = '';
        asyncUpload(file)
          .then((result) => {
            image.src = `https://cdn.naamezip.com/${result.Key}`;
          })
          .catch();
        return false;
      },
      'image.beforeUpload': function (images) {
        asyncUpload(images[0])
          .then((result) => {
            this.image.insert(`https://cdn.naamezip.com/${result.Key}`, true, null);
          })
          .catch();
        return false;
      },
      'video.beforeUpload': function (images) {
        asyncUpload(images[0])
          .then((result) => {
            this.video.insert(
              `<video controls src='https://naamezip-upload-images.s3.ap-northeast-2.amazonaws.com/${result.Key}#t=0.001'></video>`,
            );
          })
          .catch();
        return false;
      },
      // 'initialized': function () {
      //     this.html.set(options.initialHTML);
      // }
    },
    fontFamilyDefaultSelection: '본고딕',
    fontFamily: {
      'Noto Sans KR': '본고딕',
    },
  };
};

export default makeConfig;
